import { UIEvent } from 'react';
import { PhoneIcon } from '@grupoboticario/flora-react-icons';
import config from 'config';
import { ListComponentsTalkTo } from './components.styles';

export const PhoneLink = ({
  handleTrackClick,
}: {
  handleTrackClick: (event: UIEvent<HTMLAnchorElement>) => void;
}) => (
  <ListComponentsTalkTo.Li>
    <ListComponentsTalkTo.Link
      data-label="telefone"
      onClick={handleTrackClick}
      to={`tel:${config.communication.sac.phone}`}
    >
      <PhoneIcon size={12} aria-hidden="true" /> Telefone: {config.communication.sac.phone}
    </ListComponentsTalkTo.Link>
  </ListComponentsTalkTo.Li>
);
